export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-geo/src/identity.js
// module id = ../../../../d3-geo/src/identity.js
// module chunks = 3